import React from 'react';
import { SidebarLayout } from './Sidebar';
import CruxInsight from './CruxInsight';
import { spacing } from '../design-system/tokens';

/**
 * ModulePage — shared wrapper for /energy, /growth, /system, /copilot.
 * Adds the new Sidebar layout and a CruxInsight at the top with module-
 * specific stub data; renders the legacy module UI below untouched.
 *
 * Props:
 *   - currentPath
 *   - user, onSignOut
 *   - insight: { state, actions, reasons, accent, confidence }
 *   - children: legacy module UI
 */
export default function ModulePage({
  currentPath,
  user,
  onSignOut,
  insight,
  children,
}) {
  return (
    <SidebarLayout currentPath={currentPath} user={user} onSignOut={onSignOut}>
      <div style={{ maxWidth: 1100, margin: '0 auto' }}>
        {insight && (
          <div style={{ marginBottom: spacing.xl }}>
            <CruxInsight
              state={insight.state}
              actions={insight.actions}
              reasons={insight.reasons}
              accent={insight.accent}
              confidence={insight.confidence}
            />
          </div>
        )}
        {children}
      </div>
    </SidebarLayout>
  );
}
